import ContactForm from "./ContactForm";
import useScrollToTop from './useScrollToTop';

function Contact() {
useScrollToTop();
  return (
    <div>
      <header className="contact-header">
        <h1>Contact</h1>
      </header>
      <div className="contact-body">
        <h2>Contact Us</h2>
        <p>Get in touch to tell us about your project or ask any questions regarding the services we provide. Thanks for visiting and we look forward to hearing what you've been working on</p>
        <ContactForm />
      </div>
    </div>
  );
};

export default Contact;